import React from 'react'
import { loadUser } from '../../../utils/storage'
import QuestionResultContainer from '../../../components/questionnaire/resultContainer'

export default function QuestionScore() {
  const person = loadUser()
  return <QuestionResultContainer personId={person.id} />
}
